/**
 * RestaurantScroll hook
 *
 * Manages window scroll position for the unified home page as the customer
 * moves between the restaurant grid and a single restaurant's menu (both are
 * the same LiveView, navigated via push_patch which otherwise preserves
 * scroll):
 *
 *   - While the grid is visible (an element with id "restaurant-grid" is in the
 *     DOM) we continuously remember the window scroll position.
 *   - On the server-pushed "scroll-top" event (entering a restaurant) we jump
 *     to the top so the menu starts at the beginning.
 *   - On the server-pushed "restore-grid-scroll" event (tapping "All
 *     restaurants") we return to the remembered grid position.
 */
const RestaurantScroll = {
  mounted() {
    this.gridScroll = 0;

    this.onScroll = () => {
      if (document.getElementById("restaurant-grid")) {
        this.gridScroll = window.scrollY;
      }
    };
    window.addEventListener("scroll", this.onScroll, { passive: true });

    this.handleEvent("scroll-top", () => {
      window.scrollTo({ top: 0 });
    });

    this.handleEvent("restore-grid-scroll", () => {
      window.scrollTo({ top: this.gridScroll });
    });

    // The server flags the first item of a cart; the checkout-or-keep-
    // shopping prompt rides on that flag. No sessionStorage: a phone's
    // browser session lives for weeks, and a client-side once-per-session
    // latch suppressed the prompt on every order after the first.
    this.handleEvent("item-added", ({ first_add: firstAdd }) => {
      if (!firstAdd) return;

      const data = window.Alpine && window.Alpine.$data(this.el);
      if (data) {
        data.showBag = true;
        data.showFirstAdd = true;
      }
    });
  },

  destroyed() {
    window.removeEventListener("scroll", this.onScroll);
  },
};

export default RestaurantScroll;
